// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import themeCommon from './_common';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'staff-grid';
const cardClass = 'staff-card';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class StaffGrid {
  constructor(el) {
    this.el = el;
    this.$itemsPerRow = $(el).find(`.${baseClass}__items-per-row`);
    this.$cols = $(el).find(`.${baseClass}__col`);
    this.$cards = $(el).find(`.${cardClass}`);
    this.$details = $(el).find(`.${baseClass}__details`);
    this.$detailsInner = $(el).find(`.${baseClass}__details-inner`);

    this.checkDetails();
    this.updateOrder();

    $(el).on('click', '.image-leaf', this.onClick.bind(this));
    $(el).on('click', `.${cardClass}__btn`, this.onClick.bind(this));
    $(window).on('resize load', this.updateOrder.bind(this));
  }

  checkDetails() {
    this.$cards.each((i, col) => {
      if ($(col).find(`.${cardClass}__btn`).length === 0) {
        $(col).addClass(`${cardClass}--no-details`);
      }
    });
  }

  updateOrder() {
    const itemsPerRow = themeCommon.getFlexOrder(this.$itemsPerRow);
    this.$cols.each((i, col) => {
      // starting from 0, increase each row's order-number by 2
      const n = (i + 1);
      const order = (Math.ceil(n / itemsPerRow) * 2) - 2;
      let align = 'm';
      if ((n % itemsPerRow) === 0) align = 'r';
      if ((n % itemsPerRow) === 1) align = 'l';
      $(col).css({ order }).attr('data-align', align);
    });
    this.updateDetailsOrder();
  }

  updateDetailsOrder() {
    const $activeCard = this.$cards.filter('.active');
    let order = '';
    let align = '';
    if ($activeCard.length) {
      const $activeCol = this.$cols.has($activeCard);
      order = themeCommon.getFlexOrder($activeCol) + 1;
      align = $activeCol.attr('data-align');
    }
    this.$details.css({ order });
    this.$detailsInner
      .toggleClass('r', (align === 'r'))
      .toggleClass('l', (align === 'l'));
  }

  openCard($card) {
    const $cardDetails = $card.find(`.${cardClass}__details`);
    this.$cards.removeClass('active').addClass('inactive')
      .removeAttr('aria-describedby');
    $card.toggleClass('active inactive')
      .attr('aria-describedby', this.$details.attr('id'));
    this.updateDetailsOrder();
    this.$detailsInner.html($cardDetails.html());
    this.$details.removeClass('d-none');
    themeCommon.smoothScrollTo($card, 750, `-${parseInt($card.parent().css('margin-top'))}`);
  }

  reset() {
    this.$cards.removeClass('active inactive')
      .removeAttr('aria-describedby');
    this.$detailsInner.html('');
    this.$details.css('order', '').addClass('d-none');
  }

  onClick(e) {
    const $card = this.$cards.has(e.currentTarget);
    if ($card.is('.active')) {
      this.reset();
    } else {
      this.openCard($card);
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new StaffGrid(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
